/* eslint-disable no-param-reassign */
import { useMemo } from 'react';
import { types } from 'mobx-state-tree';
import type {
  Instance,
  SnapshotIn,
  SnapshotOut,
} from 'mobx-state-tree/dist/core/type/type';

import { CandidateApplicationInterviewModel } from '@/models/calendar';
import { initializeStore } from '@/stores/initializer';
import type { CandidateApplicationInterviewModelType } from '@/models/calendar';

export const StudentCalendarStore = types
  .model({
    // duplicate tz here to simplify dates update on tz change
    tz: types.maybe(types.string),
    applicationInterviews: types.array(
      types.late(() => CandidateApplicationInterviewModel),
    ),
  })
  .views((self) => ({
    getApplicationInterviewById(
      applicationId: number,
    ): CandidateApplicationInterviewModelType | undefined {
      return self.applicationInterviews.find(
        (ai) => ai.application.pk === applicationId,
      );
    },
  }))
  .named('StudentCalendarStore');

export const useStudentCalendarStore = (
  initialState: StudentCalendarStoreSnapshotIn | null = null,
): StudentCalendarStoreType | null => {
  return useMemo(
    () => initializeStore(StudentCalendarStore, initialState),
    [initialState],
  );
};

export type StudentCalendarStoreType = Instance<
  typeof StudentCalendarStore
> & {};

export type StudentCalendarStoreSnapshotIn = SnapshotIn<
  typeof StudentCalendarStore
> & {};

export type StudentCalendarStoreSnapshotOut = SnapshotOut<
  typeof StudentCalendarStore
> & {};
